import '../App.css';
import { Box, Grid, Button, Paper, Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import * as AuthenticationUtil from "../util/AuthenticationUtil";
import { Questionnaire } from '../components/Questionnaire';
import { usePageLoader } from "../util/usePageLoader";
import { useAlert } from "../util/useAlert";

import { Copyright } from "../components/Copyright";
import * as Endpoints from "../util/Endpoints";
import * as ApiUtil from "../util/ApiUtil";

import { Logout } from "../components/Logout";
import { VaccineHistory } from '../components/VaccineHistory';
import { centeredPaperStyle } from '../components/ConsentDocumentBody';

export const QuestionnairePage = (props) => {

    const [response, setResponse] = useState({});
    const [loader, showLoader, hideLoader] = usePageLoader();
    const [alert, showAlert] = useAlert();

    useEffect(() => {
        const getActiveGroupQuestionnaire = async () => {
            try {
                showLoader();
                const responseData = await ApiUtil.callBackend(Endpoints.activeGroupQuestionnaire, "GET");
                console.log(responseData);

                setResponse(responseData);

                if (!responseData.status) {
                    showAlert(responseData.message, "error");
                }
            } catch (error) {
                console.log(error);
                showAlert(error.message, "error");
            } finally {
                hideLoader();
            }
        }
        getActiveGroupQuestionnaire();

    }, []);

    if (!AuthenticationUtil.isAuthenticated()) {
        return <Redirect to="/login" />;
    }

    return (
        <div>
            <Box m={1}>
                <Grid container justifyContent="flex-end" spacing={1}>
                    <Grid item>
                        <VaccineHistory />
                    </Grid>
                    <Grid item>
                        <Logout />
                    </Grid>
                </Grid>
                <Grid container justifyContent="center">
                    <Grid item>
                        <h2>Aktiva frågeformulär</h2>
                    </Grid>
                </Grid>

                <Grid container spacing={2} justifyContent="center">
                    {response.status && response.data.groupQuestionnaires.length > 0
                        ? response.data.groupQuestionnaires.map(questionnaire => (
                            <Grid item xs={12} sm={6} md={4} key={questionnaire.id}>
                                <div style={{ width: '100%' }}>
                                    <Questionnaire data={questionnaire} />
                                </div>
                            </Grid>
                        ))
                        : (
                            <Grid item xs={12} style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                <Paper style={centeredPaperStyle}>
                                    <Box p={2} textAlign="center">
                                        <Typography variant="body2" color="textSecondary">
                                            Tack! Inga fler frågeformulär för dig just nu.
                                        </Typography>
                                    </Box>
                                </Paper>
                            </Grid>
                        )
                    }
                </Grid>
                {response.status && response.data.groupQuestionnaires.length === 1 && (
                    <Grid container justifyContent="center" style={{ marginTop: "20px" }}>
                        <Button
                            variant="contained"
                            color="primary"
                        >
                        </Button>
                    </Grid>
                )}
            </Box>
            <Copyright />
            {loader}
            {alert}
        </div>
    );
};
